// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      :host {
        display: inline-block;
        width: 100%;
      }
      .fa-refresh {
        cursor: pointer;
      }
      .mobile-menu {
        position: absolute;
        top: 100%;
        right: 0;
        padding: 1rem;
        border-radius: 0 0 0.25rem 0.25rem;
        z-index: 1000;
        width: 100%;
        max-width: 300px;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
      }
      .mobile-menu-toggle {
        padding: 0.25rem 0.5rem;
      }
    `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/units/zikata-user-info/zikata-user-info.component.ts"],"names":[],"mappings":";MACM;QACE,qBAAqB;QACrB,WAAW;MACb;MACA;QACE,eAAe;MACjB;MACA;QACE,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,aAAa;QACb,kCAAkC;QAClC,aAAa;QACb,WAAW;QACX,gBAAgB;QAChB,6CAA6C;MAC/C;MACA;QACE,uBAAuB;MACzB","sourcesContent":["\n      :host {\n        display: inline-block;\n        width: 100%;\n      }\n      .fa-refresh {\n        cursor: pointer;\n      }\n      .mobile-menu {\n        position: absolute;\n        top: 100%;\n        right: 0;\n        padding: 1rem;\n        border-radius: 0 0 0.25rem 0.25rem;\n        z-index: 1000;\n        width: 100%;\n        max-width: 300px;\n        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n      }\n      .mobile-menu-toggle {\n        padding: 0.25rem 0.5rem;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
